import { FormGroup, InputLabel, TextField } from "@mui/material";
import ErrorMessageTypo from "./ErrorMessageTypo";
import Label from "./Label";

export const BasicFormikNumber = ({
  field,
  fieldId,
  formik,
  labelAlignement = null,
  disabled = false,
}) => {
  return (
    <>
      {labelAlignement && <Label label={field.spec.label} />}
      <FormGroup
        key={fieldId}
        sx={{
          marginTop: 1,
        }}
      >
        {!labelAlignement && (
          <InputLabel htmlFor={fieldId}>{field.spec.label}</InputLabel>
        )}
        <TextField
          type="number"
          name={fieldId}
          id={fieldId}
          size="small"
          value={formik.values[fieldId]}
          onChange={formik.handleChange}
          placeholder={field.spec.placeholder}
          error={formik.errors[fieldId] ? true : false}
           disabled={disabled}
        />
        {formik.errors[fieldId] ? (
          <ErrorMessageTypo error={formik.errors[fieldId]} />
        ) : null}
      </FormGroup>
    </>
  );
};
